import ListingDetailCropForm from '@Forms/ListingDetailCropForm';
import SpecsSection from '@Sections/SpecsSection';

class CropInformationSection extends React.Component {

    //set the react state to the the same values as the model
    static modelToState(props) {
        return {
            CropsViewModel: props.model.CropsViewModel,
            SpecsViewModel: props.model.SpecsViewModel,
            PriceViewModel: props.model.PriceViewModel,
            ContactViewModel: props.model.ContactViewModel,
            IsCrop: props.model.IsCrop,
            QueryString: props.model.QueryString,
            CurrentSite: props.model.CurrentSite,
            Translations: props.model.Translations,
            HighlightErrors: {},
            FormErrors: [],
            InputErrors: {}
        };
    }

    //The props is the model passed from the view(cshtml)
    constructor(props) {
        super(props);

        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handleFormUpdate = this.handleFormUpdate.bind(this);
        this.validateCropInformation = this.validateCropInformation.bind(this);

        //updates the parent's validator to use this method 
        var masterViewState = this.props.model;
        masterViewState.validatorCropInfo = this.validateCropInformation;
        this.props.handleFormUpdate(masterViewState);

        this.state = CropInformationSection.modelToState(props);
    }

    componentWillReceiveProps(props) {
        this.setState({
            CropsViewModel: props.model.CropsViewModel,
            SpecsViewModel: props.model.SpecsViewModel,
            PriceViewModel: props.model.PriceViewModel,
            ContactViewModel: props.model.ContactViewModel,
            Translations: props.model.Translations
        });
    }

    //executes a command when you click on a button
    handleButtonClick(button) {
        switch (button) {
            case "done":
                var bHasErrors = this.validateCropInformation(true);

                if (!bHasErrors)
                    EnterInfoDone();    //CropInfoDone
                break;
            default:
                break;
        }
    }

    //updates the state in View with new values when they change. 
    handleFormUpdate(Model) {
        this.setState({
            CropsViewModel: Model.CropsViewModel || this.state.CropsViewModel,
            validatorListingDetail: Model.validatorListingDetail || this.state.validatorListingDetail,
            SpecsViewModel: Model.SpecsViewModel || this.state.SpecsViewModel,
            ValidateAndSaveSpecs: Model.ValidateAndSaveSpecs || this.state.ValidateAndSaveSpecs,
            showUnitSwitchModal: Model.SpecsViewModel.showUnitSwitchModal || this.state.showUnitSwitchModal,
            PriceViewModel: Model.PriceViewModel || this.state.PriceViewModel,
            validatorPrice: Model.validatorPrice || this.state.validatorPrice,
            validatorCropDetails: Model.validatorCropDetails || this.state.validatorCropDetails,
            ContactViewModel: Model.ContactViewModel || this.state.ContactViewModel,
            validatorContact: Model.validatorContact || this.state.validatorContact,
            HighlightErrors: Model.HighlightErrors || this.state.HighlightErrors,
            FormErrors: Model.FormErrors || this.state.FormErrors,
            InputErrors: Model.InputErrors || this.state.InputErrors,
        });

        //pass update up to MasterView
        this.props.handleFormUpdate(Model);
    }

    validateCropInformation(bSaveXML) {
        var bHasErrors = false;

        bHasErrors = this.state.validatorCropDetails(); //validatorListingDetailCrop

        if (!bHasErrors) {
            bHasErrors = this.state.ValidateAndSaveSpecs(bSaveXML);
        }

        if (!bHasErrors) {
            var state = this.state;

            var CropsViewModel = {
                BaleTypeCatID : state.CropsViewModel.BaleTypeCatID,
                NumberOfBales : state.CropsViewModel.NumberOfBales,
                NumberOfTons : state.CropsViewModel.NumberOfTons,
                TotalWeight : state.CropsViewModel.TotalWeight,
                PricePerBale : state.CropsViewModel.PricePerBale,
                PricePerTon : state.CropsViewModel.PricePerTon,
                CurrencyCodeSelected : state.CropsViewModel.CurrencyCodeSelected,
                Description : state.CropsViewModel.Description,
                PriceDescription : state.CropsViewModel.PriceDescription
            }

            var SpecsViewModel = {
                SpecPage: state.SpecsViewModel.currentPage,
                FormInputs: state.SpecsViewModel.FormInputs,
                Category: state.SpecsViewModel.Category
            }

            var objectToSend = {
                CropsViewModel : CropsViewModel,
                SpecsViewModel: SpecsViewModel,
                EmailVerified: state.ContactViewModel.EmailVerified,
                IsCrop: state.IsCrop
            }

            //save this xml
            if (bSaveXML) {
                var xhr = new XMLHttpRequest();
                xhr.open("POST", '/listinginput/details/SaveListingInfoXML' + this.state.QueryString, true);
                xhr.setRequestHeader("Content-type", "application/json");
                xhr.send(JSON.stringify(objectToSend));
            }
        }

        return bHasErrors;
    }

    handleKeyDown(e) {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.handleButtonClick("done");
            let tagetElement = this.state.IsRearrangedSite ? document.getElementById("dropbox") : document.getElementById("PrivacyBtn");
            setTimeout(() => {
                if (tagetElement) {
                    tagetElement.focus();
                }
            }, 0);
        }
    }

    //the html and react components to render
    render() {
        return (
            <div className="accordion cf" id="accordion-content-2">
                <ListingDetailCropForm
                    parentState={this.state}
                    model={this.state.CropsViewModel}
                    specsViewModel={this.state.SpecsViewModel}
                    handleFormUpdate={(e) => { this.handleFormUpdate(e); }}
                />
                <SpecsSection
                    masterViewModel={this.state}
                    model={this.state.SpecsViewModel}
                    handleFormUpdate={(e) => { this.handleFormUpdate(e); }}
                />
                <button role="link" className="form-btn" id="info-done-btn" onKeyDown={(e) => { this.handleKeyDown(e) }} onMouseUp={(e) => { this.handleButtonClick("done"); }}>Done With Hay / Straw Information</button>
            </div>
        );
    }
}

export default CropInformationSection;
global.CropInformationSection = CropInformationSection;